// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"45955054","786":"5f9cca1d","880":"84d0dc95"}[chunkId] + ".chunk.css";
};